// extracted by mini-css-extract-plugin
export default {"selector":"selector_selector__zipKP","selectorName":"selector_selectorName__UM6xC"};